exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body, body * {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  overflow-y: scroll;\r\n}\r\n\r\n.App {\r\n  position: relative;\r\n}\r\n\r\n.Card {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n.Card__centering {\r\n  height: 100%;\r\n}\r\n\r\n.Card__centering,\r\n.Card__content {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.App__baseVals {\r\n  padding: 15px;\r\n}\r\n\r\n.Card__container {\r\n  display: inline-block;\r\n  padding: 15px;\r\n  text-align: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  background: #3e2b50;\r\n  color: white;\r\n  box-shadow: 5px 6px 9px 0px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\r\n  overflow: auto;\r\n}\r\n\r\n.App dl,\r\n.App dt,\r\n.App dd {\r\n  margin: 0;\r\n}\r\n\r\n.App__AddNewItem {\r\n  display: inline-block;\r\n  width: 200px;\r\n  height: 100px;\r\n  max-width: 100%;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./demo/src/App.Builder.css
// module id = 17
// module chunks = 2